import React from 'react';
import DateScenarioPage from '../date-management/DateScenarioPage';

const registrationEndpoints = {
  list: ({ universityId, cityId }) => ({
    url: universityId
      ? `universities/${universityId}/registration-dates`
      : cityId
        ? `universities/cities/${cityId}/registration-dates`
        : '',
  }),
  create: ({ universityId }) => ({
    url: universityId ? `universities/${universityId}/registration-dates` : '',
  }),
  update: ({ universityId, recordId }) => ({
    url: universityId ? `universities/${universityId}/registration-dates/${recordId}` : '',
  }),
  delete: ({ universityId, recordId }) => ({
    url: universityId ? `universities/${universityId}/registration-dates/${recordId}` : '',
  }),
};

const RegistrationDatesPage = () => {
  return (
    <DateScenarioPage
      titleKey="REGISTRATION_DATES_TITLE"
      subtitleKey="REGISTRATION_DATES_SUBTITLE"
      entityNameKey="DATE_SCENARIO_ENTITY_REGISTRATION"
      emptyStateKey="REGISTRATION_DATES_EMPTY"
      addButtonKey="REGISTRATION_DATES_ADD_BUTTON"
      scenarioType="registrationDates"
      endpoints={registrationEndpoints}
      usageInfoKey="REGISTRATION_DATES_USAGE_INFO"
    />
  );
};

export default RegistrationDatesPage;

